export enum RseeSummaryTypeEnum {
  RSEE_DOWNLOADING = "RSEE_DOWNLOADING",
  RSEE_DASHBOARD = "RSEE_DASHBOARD",
}
